import React from "react";
import { useTranslation } from "react-i18next";
import "./CallStartOverlay.css";

export default function CallStartOverlay({
  message,
}) {
  const { t } = useTranslation();

  const text =
    message ||
    t("calls.starting", {
      defaultValue: "جاري تجهيز المكالمة...",
    });

  return (
    <div
      className="call-start-overlay"
      role="alertdialog"
      aria-busy="true"
      aria-live="polite"
      aria-label={text}
    >
      <div className="call-start-overlay__card">
        <div className="call-start-overlay__spinner" aria-hidden />
        <p className="call-start-overlay__text">{text}</p>
      </div>
    </div>
  );
}
